import { ExternalLink } from "lucide-react"

interface CorporationOwner {
  siren?: string
  denomination?: string
  formeJuridique?: string
  formeJuridiqueAbregee?: string
}

interface OwnerCardProps {
  parcel: { corporationOwners?: CorporationOwner[] }
}

export const OwnerCard = ({ parcel }: OwnerCardProps) => {
  if (!parcel?.corporationOwners || parcel.corporationOwners.length === 0) return null

  return (
    <div className="space-y-2">
      {parcel.corporationOwners.map((owner) => (
        <div key={owner.siren} className="border-l-2 border-primary/40 pl-3 py-1">
          <div className="text-sm font-medium text-primary">{owner.denomination}</div>
          <div className="text-sm text-muted-foreground mt-0.5 flex items-center gap-2">
            {owner.formeJuridique && (
              <span className="bg-muted text-xs rounded-sm px-1 py-px">
                {owner.formeJuridiqueAbregee || owner.formeJuridique}
              </span>
            )}
            {owner.siren && <span className="text-muted-foreground">SIREN {owner.siren}</span>}
          </div>
          {owner.siren && (
            <a
              href={`https://www.pappers.fr/entreprise/${owner.siren}`}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-1 text-sm text-primary hover:text-primary/80 mt-1"
            >
              Fiche Pappers
              <ExternalLink className="w-3 h-3" />
            </a>
          )}
        </div>
      ))}
    </div>
  )
}
